import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import * as authActions from "../../actions/authActions";
import * as experiencesActions from "../../actions/experiencesActions";
import * as controlPanelActions from "../../actions/controlPanelActions";
import * as responsiveActions from "../../actions/responsiveActions";
import Dropdown from "./Dropdown";
import GlobalPreview from "../shared/GlobalPreview";
import Logo from "../../assets/img/verris-badge-dark.png";
import parseAppKey from "../../helpers/routeHelpers/parseAppKey";
import UserHasPermission from "../../helpers/validation/userHasPermission";
import GetItem from "../../helpers/dataProviders/getItem";
import PutItem from "../../helpers/dataProviders/putItem";

class TopBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			appIsLocked: false,
			appKey: parseAppKey(),
			global: "unlocked",
			app: "unlocked",
		};
		if (props.auth.user) {
			this.lockChecker = setTimeout(() => {
				this.checkLock();
			}, 100);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		let appKey = parseAppKey();
		if (appKey !== prevState.appKey) {
			this.setState({ appKey });
			if (this.lockChecker) {
				clearTimeout(this.lockChecker);
			}
			this.lockChecker = setTimeout(() => {
				this.checkLock();
			}, 100);
		}
		if (!prevProps.auth.user && this.props.auth.user) {
			this.checkLock();
		}
	}

	checkLock = () => {
		if (this.state.appKey && this.state.appKey !== "add") {
			GetItem(`/apps/${this.state.appKey}/lock`, false).then(data => {
				let newState = {};
				let update = false;
				let { global, app } = data.data;
				if (global !== this.state.global) {
					update = true;
					newState.global = global;
				}
				if (app !== this.state.app) {
					update = true;
					newState.app = app;
				}
				if (app === "locked" || global === "locked") {
					newState.appIsLocked = true;
				} else {
					newState.appIsLocked = false;
				}
				if (update) {
					this.setState(newState);
				}
			});
		}
		this.lockChecker = setTimeout(() => {
			this.checkLock();
		}, 10000);
	};

	logOut = event => {
		event.preventDefault();
		this.props.authActions.logoutUser();
	};
	toggleSidebar = () => {
		window.$("body").toggleClass("sidebar-collapse");
	};
	toggleAppPreview = () => {
		this.props.controlPanelActions.toggleAppPreview();
	};
	changeApplication = id => {
		this.props.experiencesActions.selectExperience(id);
	};

	toggleLock = () => {
		const { appIsLocked, global } = this.state;
		//if global, do nothing
		if (global !== "locked") {
			//if app, switch
			PutItem(`/apps/${this.state.appKey}/lock`, { isLocked: !appIsLocked }).then(() => {
				if (this.lockChecker) {
					clearTimeout(this.lockChecker);
				}
				this.lockChecker = setTimeout(() => {
					this.checkLock();
				}, 100);
			});
		}
	};

	lockDropdown = () => {
		const { appIsLocked, global } = this.state;
		let validUser = false;
		if (this.props.verrisUser && this.props.verrisUser.user) {
			validUser = UserHasPermission(this.props.verrisUser.user, "full");
		}
		return (
			<ul className="dropdown-menu pull-right p-left p-right" role="menu">
				{global === "locked" ? (
					<div className="alert-danger p-left p-right p-top p-bottom">
						<span>Updates Locked</span>
						<br />
						<small>
							{"You can still make updates and they'll be applied soon once updates have been unlocked"}
						</small>
					</div>
				) : validUser ? (
					<div className={`on-off-item ${appIsLocked ? "on" : "off"}`} onClick={this.toggleLock}>
						<div className="on-off-switch"></div>
						<span>{appIsLocked ? "Updates Locked" : "Updates Unlocked"}</span>
						<br />
						<small>
							{appIsLocked
								? "All updates will be applied once the app is unlocked"
								: "Click to lock updates and release several changes to your app at once"}
						</small>
					</div>
				) : (
					<div className={`${appIsLocked ? "alert-danger" : ""} p-left p-right p-top p-bottom`}>
						<span>{appIsLocked ? "Updates Locked" : "Updates Unlocked"}</span>
						<br />
						<small>{appIsLocked ? "All updates will be applied once the app is unlocked" : ""}</small>
					</div>
				)}
			</ul>
		);
	};

	toggleSideMenu = (action = null) => {
		const {
			responsive: { displaySideMenu },
			responsiveActions: { hideSideMenu, showSideMenu },
		} = this.props;

		if (typeof action === "string") {
			if (action === "hide") {
				hideSideMenu();
			}
			if (action === "show") {
				showSideMenu();
			}
		} else {
			if (displaySideMenu) {
				hideSideMenu();
			} else {
				showSideMenu();
			}
		}
	};

	render() {
		const { appIsLocked } = this.state;

		const {
			auth,
			apps,
			displayPreview,
			experiences,
			isFullWidth,
			match,
			responsive: { displaySideMenu },
			pages,
			verrisUser,
		} = this.props;
		const { user } = auth;
		let userImage = null;
		let firstName = "";
		let lastName = "";

		const isAppPage = Object.keys(match.params).includes("appKey");

		if (user && user.photoURL) {
			userImage = user.photoURL;
			if (user.displayName && user.displayName.length > 0) {
				const name = user.displayName.split(" ");

				firstName = name[0];
				lastName = name[name.length - 1];
			} else {
				firstName = verrisUser.user.firstName;
				lastName = verrisUser.user.lastName;
			}
		} else if (verrisUser) {
			if (verrisUser.user) {
				firstName = verrisUser.user.firstName;
				lastName = verrisUser.user.lastName;
			}
		}
		const profileContent = () => (
			<ul className="dropdown-menu pull-right" role="menu">
				<li>
					<div className="user-info">
						<div className="user-name">{firstName}</div>
						<div className="user-position online">{lastName}</div>
					</div>
				</li>
				<li>
					<a onClick={() => window.displayPreferenceModal()}>Manage Cookie Preferences</a>
				</li>
				<li>
					<a
						onClick={event => {
							this.logOut(event);
						}}
						role="button"
						tabIndex="0"
					>
						<i className="fa fa-sign-out"></i>Logout
					</a>
				</li>
			</ul>
		);

		let { appKey, expId, pageId } = this.props.match.params;
		const appsMenu = () => (
			<div>
				{apps.apps && apps.apps.length > 0 && (
					<ul className="dropdown-menu pull-left" role="menu">
						{apps.apps.map(app => {
							return (
								<li key={app.id}>
									<Link to={`/apps/${app.key}`} onClick={() => this.toggleSideMenu("hide")}>
										<span className="block">{app.name}</span>
									</Link>
								</li>
							);
						})}
					</ul>
				)}
			</div>
		);
		const experienceMenu = () => (
			<div>
				{experiences.experiences && experiences.experiences.length > 0 && (
					<ul className="dropdown-menu pull-left" role="menu">
						{experiences.experiences.map(experience => {
							return (
								<li key={experience.id}>
									<Link
										to={`/apps/${appKey}/experiences/${experience.id}`}
										onClick={() => this.toggleSideMenu("hide")}
									>
										<span role="button" className="media">
											<span className="block">{experience.name}</span>
										</span>
									</Link>
								</li>
							);
						})}
					</ul>
				)}
			</div>
		);
		const pageMenu = () => (
			<div>
				{pages.pages && pages.pages.length > 0 && (
					<ul className="dropdown-menu pull-left" role="menu">
						{pages.pages.map(page => {
							return (
								<li key={page.id}>
									<Link
										to={`/apps/${appKey}/experiences/${expId}/pages/${page.id}`}
										onClick={() => this.toggleSideMenu("hide")}
									>
										<span role="button" className="media">
											<span className="block">{page.name}</span>
										</span>
									</Link>
								</li>
							);
						})}
					</ul>
				)}
			</div>
		);
		let appName = "";
		let expName = "";
		let pageName = "";

		if (appKey) {
			if (this.props.apps.apps) {
				let app = this.props.apps.apps.find(app => {
					return app.key === appKey;
				});
				if (app) {
					appName = app.name;
				}
			}
		}
		if (expId) {
			if (experiences.experiences && experiences.experiences.length > 0) {
				expName = experiences.experiences.find(experience => experience.id === expId).name;
			}
		}
		if (pageId) {
			if (pages.pages && pages.pages.length > 0) {
				let page = pages.pages.find(page => page.id === pageId);
				if (page) {
					pageName = page.name;
				}
			}
		}

		return (
			<div>
				<div>
					<div
						className={`coverall more global-coverall${displayPreview ? " on" : ""}`}
						onClick={() => this.toggleAppPreview()}
					></div>
					{displayPreview && appKey && (
						<div className="global-preview absolute-center global pop-up-box">
							<GlobalPreview appKey={appKey} />
						</div>
					)}
				</div>
				<header
					className={`main-header${isFullWidth ? " full-width" : ""}${
						displaySideMenu ? " sidebar-open" : ""
					}`}
				>
					{auth.user && (
						<div>
							<nav className="navbar-static-top">
								{isFullWidth && (
									<div className="topbar-logo">
										<img src={Logo} alt="logo" />
									</div>
								)}
								{isAppPage && (
									<div className="mobile-menu">
										<button className="menu-button pull-left" onClick={this.toggleSideMenu}>
											<i className="fal fa-bars"></i>
										</button>
									</div>
								)}
								<div className="nav-breadcrumbs">
									{appKey && apps.apps && apps.apps.length > 0 && (
										<div className="pull-left" style={{ margin: "0 15px" }}>
											<Dropdown content={appsMenu} classNames="app-switcher">
												<span style={{ marginRight: "8px" }}>{appName}</span>
												<i className="fal fa-chevron-right mx-5"></i>
											</Dropdown>
										</div>
									)}
									{expId && experiences.experiences && experiences.experiences.length > 0 && (
										<div className="pull-left" style={{ margin: "0 15px" }}>
											<Dropdown content={experienceMenu} classNames="app-switcher">
												<span style={{ marginRight: "8px" }}>{expName}</span>
												<i className="fal fa-chevron-right mx-5"></i>
											</Dropdown>
										</div>
									)}
									{pageId && pages.pages && pages.pages.length > 0 && (
										<div className="pull-left" style={{ margin: "0 15px" }}>
											<Dropdown content={pageMenu} classNames="app-switcher">
												<span style={{ marginRight: "8px" }}>{pageName}</span>
												<i className="fal fa-chevron-right mx-5"></i>
											</Dropdown>
										</div>
									)}
								</div>

								<div className="navbar-custom-menu">
									{appKey && (
										<ul
											className="nav navbar-nav nav-btn hide-tablet"
											title="Preview App"
											onClick={() => this.toggleAppPreview()}
										>
											<i className="fal fa-play"></i>
										</ul>
									)}
									{isAppPage && (
										<ul className={`nav navbar-nav${appIsLocked ? " locked" : ""} hide-tablet`}>
											<Dropdown content={this.lockDropdown} classNames="app-lock app-lock-menu">
												<i className={`fal ${appIsLocked ? "fa-lock" : "fa-unlock"}`}></i>
											</Dropdown>
										</ul>
									)}
									<ul className="nav navbar-nav">
										<Dropdown content={profileContent} classNames="user user-menu">
											{userImage ? (
												<span>
													<img
														src={userImage}
														alt={user.displayName}
														className="user-image"
													/>
													<span className="hidden-xs user-name-fix">&nbsp;</span>
												</span>
											) : (
												<div className="user-initials">
													{firstName.charAt(0).toUpperCase()}
													{lastName.charAt(0).toUpperCase()}
												</div>
											)}
										</Dropdown>
									</ul>
								</div>
							</nav>
						</div>
					)}
				</header>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
	apps: state.apps,
	config: state.config,
	displayPreview: state.controlPanel.displayPreview,
	experiences: state.experiences,
	pages: state.pages,
	responsive: state.responsive,
	verrisUser: state.user,
});

const mapDispatchToProps = dispatch => ({
	authActions: bindActionCreators(authActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
	experiencesActions: bindActionCreators(experiencesActions, dispatch),
	responsiveActions: bindActionCreators(responsiveActions, dispatch),
});

TopBar.propTypes = {
	actions: PropTypes.any,
	apps: PropTypes.object,
	auth: PropTypes.object,
	authActions: PropTypes.object,
	config: PropTypes.object,
	controlPanelActions: PropTypes.object,
	displayPreview: PropTypes.bool,
	experiences: PropTypes.object,
	experiencesActions: PropTypes.object,
	isFullWidth: PropTypes.bool,
	match: PropTypes.object,
	pages: PropTypes.object,
	verrisUser: PropTypes.object,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(TopBar));
